function showIframesForDev() {
    document.querySelectorAll('iframe[data-cookieblock-src]').forEach(iframe => {
        iframe.setAttribute('src', iframe.getAttribute('data-cookieblock-src'));
        iframe.style.setProperty('display', 'block', 'important');
    });
}

showIframesForDev();
window.addEventListener('CookiebotOnLoad', showIframesForDev);
window.addEventListener('CookiebotOnConsentReady', showIframesForDev);

// Watch for Cookiebot re-hiding the iframes and override it
const observer = new MutationObserver(() => {
    document.querySelectorAll('iframe[data-cookieblock-src]').forEach(iframe => {
        if (iframe.style.display === 'none') {
            iframe.style.setProperty('display', 'block', 'important');
        }
    });
});

observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
});


document.querySelectorAll('.frame-type-html iframe').forEach(iframe => {
    iframe.setAttribute('scrolling', 'no');

    let expanded = false;
    window.addEventListener('blur', function () {
        if (expanded) return;
        setTimeout(function () {
            if (document.activeElement === iframe) {
                expanded = true;
                iframe.classList.add('linkedin-expanded');
            }
        }, 0);
    });

    const src = iframe.getAttribute('data-cookieblock-src') || iframe.getAttribute('src') || '';
    if (src.includes('linkedin.com/embed/feed/update/')) {
        // Derive the public post URL from the embed URL by removing /embed/ and query params
        const postUrl = src.replace('/embed/', '/').split('?')[0];

        const wrapper = iframe.parentElement;
        if (getComputedStyle(wrapper).position === 'static') {
            wrapper.style.position = 'relative';
        }

        const overlay = document.createElement('a');
        overlay.href = postUrl;
        overlay.target = '_blank';
        overlay.rel = 'noopener noreferrer';
        overlay.className = 'linkedin-image-overlay';
        wrapper.appendChild(overlay);
    }

    // If LinkedIn's embed page sends its rendered height via postMessage, use that exact value
    window.addEventListener('message', function (event) {
        if (event.source !== iframe.contentWindow) return;
        try {
            const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            const height = data?.height ?? data?.newHeight ?? data?.data?.height;
            if (height && parseInt(height) > 100) {
                iframe.style.setProperty('height', (parseInt(height) + 20) + 'px', 'important');
            }
        } catch (e) { }
    });
});


const cookieVideoIframes = document.querySelectorAll('iframe[data-cookieconsent="marketing"]');


if (cookieVideoIframes.length !== 0) {
    cookieVideoIframes.forEach(iframe => {
        // Check if Cookiebot consent exists and marketing is not accepted
        if (typeof Cookiebot !== 'undefined' && !Cookiebot.consent.marketing) {
            createPlaceholder(iframe);
        }
    });
}

function createPlaceholder(iframe) {
    const container = iframe.parentElement;

    // Check if placeholder already exists
    if (container.querySelector('.video-cookie-placeholder')) {
        return;
    }

    // Detect language from URL
    const isGerman = window.location.pathname.includes('/de');

    // Translations
    const translations = {
        title: isGerman ? 'Videoinhalt blockiert' : 'Video Content Blocked',
        text: isGerman ? 'Um dieses Video anzusehen, akzeptieren Sie bitte Marketing-Cookies.' : 'To view this video, please accept marketing cookies.',
        button: isGerman ? 'Cookies akzeptieren' : 'Accept Cookies'
    };

    // Get iframe dimensions
    const iframeWidth = iframe.getAttribute('width') || '600';
    const iframeHeight = iframe.getAttribute('height') || '337';

    // Create placeholder element
    const placeholder = document.createElement('div');
    placeholder.className = 'video-cookie-placeholder';

    // Calculate aspect ratio from iframe dimensions
    const aspectRatio = (iframeHeight / iframeWidth) * 100;
    placeholder.style.paddingBottom = aspectRatio + '%';

    placeholder.innerHTML = `
<div class="placeholder-content">
<svg class="placeholder-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
<polygon points="5 3 19 12 5 21 5 3"></polygon>
</svg>
<h3 class="placeholder-title">${translations.title}</h3>
<p class="placeholder-text">${translations.text}</p>
<button class="placeholder-cta" onclick="Cookiebot.renew()">
<span>${translations.button}</span>
<svg class="cta-arrow" width="22" height="12" viewBox="0 0 22 12" xmlns="http://www.w3.org/2000/svg">
<path d="M1 5.25C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75V5.25ZM21.5303 6.53033C21.8232 6.23744 21.8232 5.76256 21.5303 5.46967L16.7574 0.696699C16.4645 0.403806 15.9896 0.403806 15.6967 0.696699C15.4038 0.989593 15.4038 1.46447 15.6967 1.75736L19.9393 6L15.6967 10.2426C15.4038 10.5355 15.4038 11.0104 15.6967 11.3033C15.9896 11.5962 16.4645 11.5962 16.7574 11.3033L21.5303 6.53033ZM1 6.75H21V5.25H1V6.75Z"/>
</svg>
</button>
</div>
`;

    // Insert placeholder before iframe
    container.insertBefore(placeholder, iframe);
}

// Listen for Cookiebot acceptance
window.addEventListener('CookiebotOnAccept', () => {
    if (Cookiebot.consent.marketing) {
        // Remove all placeholders
        const placeholders = document.querySelectorAll('.video-cookie-placeholder');
        placeholders.forEach(placeholder => {
            placeholder.remove();
        });
    }
});

// Listen for Cookiebot decline/withdrawal
window.addEventListener('CookiebotOnDecline', () => {
    handleCookieDecline();
});

// Also listen for consent changes (when user withdraws consent)
window.addEventListener('CookiebotOnConsentReady', () => {
    if (!Cookiebot.consent.marketing) {
        handleCookieDecline();
    }
});

function handleCookieDecline() {
    // Re-check all iframes and add placeholders if needed
    const allIframes = document.querySelectorAll('iframe[data-cookieconsent="marketing"]');
    allIframes.forEach(iframe => {
        createPlaceholder(iframe);
    });
}